module.exports = __webpack_public_path__ + "static/media/alanChristopherNeal.f4b92f8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/alanChristopherNeal.jpg
// module id = 1659
// module chunks = 1